// 互动课堂

import React, { useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
// import SwiperCore, { Pagination } from 'swiper/core';
// import SwiperClass from 'swiper/types/swiper-class';

import classNames from 'classnames';
import { PC, Mobile } from '@wukong/haomao';

// import { ISwiper, SwiperSlide } from '@/components/Swiper';
// import 'swiper/components/pagination/pagination.min.css';

// SwiperCore.use([Pagination]);

import { Pagination, Swiper as S } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import styles from './style.module.scss';
import { MyContext } from '../../../../config/context-manager';
import useIsMobile from '../../../../hooks/useIsMobile';
import 'swiper/css';
import 'swiper/css/pagination';

S.use([Pagination]);

interface InteractProps {
  picture: string;
  title: string;
  desc: string;
  idx: number;
}

const InteractItem = ({ picture, title, desc, idx }: InteractProps) => {
  return (
    <dl className={classNames(styles.card, styles[`card-${idx}`])}>
      <dt className={styles.imageContainer}>
        <Image src={picture} layout="fill" objectFit="cover" alt={`悟空中文特色 趣味探索的方法启发互动课堂 ${title}`} />
      </dt>
      <dd className={styles.cardContent}>
        <div className={styles.cardContentInner}>
          <h4
            className={classNames(styles.cardTitle, {
              [styles.mb10]: idx === 2,
            })}
          >
            {title}
          </h4>
          <p className={styles.desc} dangerouslySetInnerHTML={{ __html: desc }} />
        </div>
      </dd>
    </dl>
  );
};

const CourseInteract = () => {
  const { t } = useTranslation('chineseSpecialty');
  const { locale } = useContext(MyContext);

  const isMobile = useIsMobile();
  const swiperRef = useRef<SwiperClass>();

  const featureConfig: InteractProps[] = [
    {
      title: t('互动课堂-内容-1-标题'),
      picture: '/images/chinese-math-class/chinese/specil/interact-introduce-1.png',
      desc: t('互动课堂-内容-1-介绍'),
      idx: 0,
    },
    {
      title: t('互动课堂-内容-2-标题'),
      picture: '/images/chinese-math-class/chinese/specil/interact-introduce-2.png',
      desc: t('互动课堂-内容-2-介绍'),
      idx: 1,
    },
    {
      title: t('互动课堂-内容-3-标题'),
      picture: '/images/chinese-math-class/chinese/specil/interact-introduce-3.png',
      desc: t('互动课堂-内容-3-介绍'),
      idx: 2,
    },
    {
      title: t('互动课堂-内容-4-标题'),
      picture: '/images/chinese-math-class/chinese/specil/interact-introduce-4.png',
      desc: t('互动课堂-内容-4-介绍'),
      idx: 3,
    },
    {
      title: t('互动课堂-内容-5-标题'),
      picture: '/images/chinese-math-class/chinese/specil/interact-introduce-5.png',
      desc: t('互动课堂-内容-5-介绍'),
      idx: 4,
    },
    {
      title: t('互动课堂-内容-6-标题'),
      picture: '/images/chinese-math-class/chinese/specil/interact-introduce-6.png',
      desc: t('互动课堂-内容-6-介绍'),
      idx: 5,
    },
  ];

  const handleSwiperInit = (swiper: SwiperClass) => {
    swiperRef.current = swiper;
  };

  useEffect(() => {
    if (isMobile) {
      swiperRef.current?.enable();
    } else {
      swiperRef.current?.disable();
    }
  }, [isMobile]);

  return (
    <section
      className={classNames(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <div className={styles.mTitleContainer}>
        <h3 dangerouslySetInnerHTML={{ __html: t('互动课堂-标题') }} />
        <div className={styles.titleIconBox}>
          <Image
            src="/images/chinese-math-class/chinese/specil/interact-title-icon.png"
            width={24}
            height={30}
            layout="responsive"
            alt=""
          />
        </div>
      </div>
      <PC>
        <div className={styles.multiContainer}>
          <div className={styles.multiColumnContainer}>
            {featureConfig.map((item, index) => (
              <div key={item.title} className={styles.multiItem}>
                <InteractItem desc={item.desc} title={item.title} picture={item.picture} idx={index} />
              </div>
            ))}
          </div>
        </div>
      </PC>
      <Mobile>
        <div>
          <div className={styles.cardBox}>
            <Swiper
              className={styles.swiper}
              onInit={handleSwiperInit}
              enabled={isMobile}
              loop={isMobile}
              slidesPerView={1}
              // slidesPerColumn={1}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                '720': {
                  slidesPerView: 3,
                },
              }}
            >
              {featureConfig.map((item) => (
                <SwiperSlide key={`${item.title}`}>
                  <InteractItem desc={item.desc} title={item.title} picture={item.picture} idx={item.idx} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </Mobile>
    </section>
  );
};

export default CourseInteract;
